<form [formGroup]="_filterForm">
    <div class="flex-container">
        <mat-form-field class="form-field flex-item">
            <mat-label>{{ 'clientFilter.clientId' | transloco }}</mat-label>
            <input matInput [formControlName]="'clientID'" [placeholder]="'clientFilter.clientId' | transloco" />
        </mat-form-field>
    </div>

    <div class="flex-container">
        <mat-checkbox formControlName="isActive" class="form-field">
            {{ 'common.labels.active' | transloco }}
        </mat-checkbox>
    </div>

    <div class="spacer-small"></div>

    <div>
        <button mat-raised-button color="accent" class="margin-sides-5" [attr.aria-label]="'common.labels.clearFiltersButton' | transloco" type="button"
            (click)="onClear()" [disabled]="!_filterForm.dirty">
            {{ 'common.labels.clearFilters' | transloco }}
        </button>
        <button mat-raised-button color="accent" class="margin-sides-5" [attr.aria-label]="'common.labels.filterButton' | transloco" type="submit"
            (click)="onFilter()">
            {{ 'common.labels.filter' | transloco }}
        </button>
    </div>
</form>